module.exports = __webpack_public_path__ + "static/media/chevron-large--disabled.cec8cc67.svg";